export default __webpack_public_path__ + "1485d80bf8b665dfbad7bae88cf8d7b5.png";